
import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './Icons.scss'

export const Icon = ({ children, className, family, icon, tooltipText, onClick, ...other }) => {
  const classNames = classnames(className, {
    'fa': family === 'fa',
    [`fa-${icon}`]: family === 'fa',
    'icon-sli': family === 'sli',
    [`icon-${icon}`]: family === 'sli',
    'icon-link': typeof onClick === 'function'
  })

  return (
    <i className={classNames} onClick={onClick} {...other} data-tip={tooltipText}>{children}</i>
  )
}

Icon.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  family: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  tooltipText: PropTypes.string,
  onClickButton: PropTypes.func
}
